var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStatistics(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 46 42",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#304256"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.8 11.9c0-.1 0-.1-.1-.1 0-.1-.1-.1-.1-.2s-.1-.1-.1-.1c0-.1-.1-.1-.1-.2l-.2-.2-.1-.1-.1-.1-.2-.2c-.1-.1-.1-.1-.2-.1s-.1-.1-.1-.1c-.1 0-.1-.1-.2-.1s-.1 0-.1-.1c-.1 0-.2-.1-.4-.1H22.6c-1 0-1.8.8-1.8 1.8s.8 1.8 1.8 1.8h7.8L22.2 22l-2.7-2.5c-.7-.7-1.8-.7-2.5.1l-9 9.1c-.7.7-.7 1.9 0 2.5.4.4.8.5 1.3.5.4 0 .9-.2 1.3-.5l7.8-7.8 2.7 2.5c.7.7 1.8.7 2.5-.1l9.4-9.4v7.8c0 1 .8 1.8 1.8 1.8s1.8-.8 1.8-1.8V12c.3.1.3 0 .2-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8.2H8.1C3.7.2.2 3.7.2 8.1v26c0 4.4 3.5 7.9 7.9 7.9h29.7c4.4 0 7.9-3.5 7.9-7.9v-26c0-4.4-3.5-7.9-7.9-7.9zm4.3 33.9c0 2.4-1.9 4.2-4.2 4.2H8.2c-2.4 0-4.2-1.9-4.2-4.2v-26c0-2.4 1.9-4.2 4.2-4.2h29.7c2.4 0 4.2 1.9 4.2 4.2v26z"
  }))));
}

export default SvgStatistics;